export const ERROR = -1;
export const NOT_AVAILABLE = 0;
export const DEVICE_ALREADY_ASSIGED = 1;
export const DEVICE_SIM_NOT_ACTIVATED = 2;
export const DEVICE_READY_TO_ASSIGN = 3;
